import { render } from "./SelectChallengeProblem.vue?vue&type=template&id=1843718c&scoped=true&ts=true"
import script from "./SelectChallengeProblem.vue?vue&type=script&lang=ts"
export * from "./SelectChallengeProblem.vue?vue&type=script&lang=ts"

import "./SelectChallengeProblem.vue?vue&type=style&index=0&id=1843718c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1843718c"]])

export default __exports__